import { useForm } from '@mantine/form';
import { useState } from 'react';
import {
	validateNumber,
	validateText,
} from '../../../util/validation/commonValidation';
import type { UpsertBranchStockDto } from '../types/BranchStockDto';

const defaultBranchStock: UpsertBranchStockDto = {
	branchIds: [],
	isEdit: false,
};

export function useUpsertBranchStockForm(
	skuid: string,
	branchStock: UpsertBranchStockDto = defaultBranchStock,
) {
	const [inputs, setInputs] = useState<UpsertBranchStockDto>({
		...branchStock,
		skuid: skuid,
	});

	const form = useForm<UpsertBranchStockDto>({
		mode: 'uncontrolled',
		initialValues: {
			...branchStock,
			skuid: skuid,
		},
		validate: {
			description: (value) => validateText(value, false, 'Description', 150),
			minStock: (v) =>
				validateNumber(
					v?.toString(),
					false,
					-1000000,
					1000000,
					'Minimum stock',
					false,
				),
			maxStock: (v) =>
				validateNumber(
					v?.toString(),
					false,
					-1000000,
					1000000,
					'Maximum stock',
					false,
				),
			stock: (v) =>
				validateNumber(
					v?.toString(),
					false,
					-1000000,
					1000000,
					'Current stock',
					false,
				),
			branchIds: (value, values) => {
				if (!values.isEdit && value.length < 1) {
					return 'Please select at least one branch';
				}
			},
		},
		onValuesChange: (v) => setInputs(v),
	});

	return { form, inputs };
}
